import React, { useEffect, useState } from 'react';
import './paymentDrawer.scss';
import '../../molecules/PaymentBox/methodSwitch.scss';
import BtnCircular from '../../../ds/BtnCircular/BtnCircular';
import PaymentNusxa from '../../molecules/PaymentNusxa/PaymentNusxa';
import SelectAddress from '../../molecules/SelectAddress/SelectAddress';
import PaymentSummary from '../../molecules/PaymentSummary/PaymentSummary';
import PickupLocationBox from '../../molecules/PickupLocationBox/PickupLocationBox';
import ListItem from '../../../ds/ListItem/ListItem';
import OrderTableLabel from '../../../ds/OrderTableLabel/OrderTableLabel';
import ChooseAddressBox from '../../molecules/ChooseAddressBox/ChooseAddressBox';
import { useContent, useLanguages } from '../../../hooks/content';
import { Returntext } from '../../../pages/Landings/common/returnText';
import { useCustomerAddresses } from '../../../hooks/address';
import { usePickupLocations } from '../../../hooks/pickupLocations';
import { ReactComponent as CloseIcon } from '../../../icons/x.svg';
import { ReactComponent as HomeIcon } from '../../../icons/home.svg';
import { ReactComponent as WorkIcon } from '../../../icons/work.svg';
import { ReactComponent as ArrowRightIcon } from '../../../icons/arrow-r.svg';
import useMobileVhFix from '../../../hooks/height';
import Lottie from 'lottie-react';
import LoaderAnimation from '../../../assets/animations/Loaders/1 - Green/data.json';

const MODE = {
  DELIVERY: 'delivery',
  PICKUP: 'pickup',
};

const PaymentDrawer = ({
  cancelClick,
  activeOrder,
  nextClick,
  setAddressDrawer,
  all,
  setActiveOrder,
  useraddress,
}) => {
  const [selectedOrders, setSelectedOrders] = useState([
    activeOrder !== undefined && activeOrder,
  ]);

  const [totalValue, setTotalValue] = useState(activeOrder?.prices?.total);

  const [cadActive, setCadActive] = useState(false);

  const { lang } = useLanguages();
  const { contentManagementData } = useContent();

  const { customerAddresses } = useCustomerAddresses();
  const { pickupLocations } = usePickupLocations();

  const [address, setAddress] = useState(
    customerAddresses !== undefined && customerAddresses.length !== 0
      ? customerAddresses.find((address) => address.isDefault === true)
      : '',
  );

  const initialMode = activeOrder?.location_id ? MODE.PICKUP : MODE.DELIVERY;
  const [mode, setMode] = useState(initialMode);
  const [pickupLocationId, setPickupLocationId] = useState(
    activeOrder?.location_id || '',
  );

  const pickupAvailable = pickupLocations.length > 0;

  // Pickup has its own copy ("<key>_pickup" in content management); falls
  // back to the delivery text until those identifiers are filled in.
  const modeText = (key) =>
    (mode === MODE.PICKUP &&
      Returntext(contentManagementData, `${key}_pickup`, lang)) ||
    Returntext(contentManagementData, key, lang);

  useMobileVhFix();

  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoader(false);
    }, 3500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="pod-drawer">
      <div className="shadow" onClick={cancelClick}></div>
      <div className={`drawer-wrap ${loader && 'load'}`}>
        <div className="header">
          <div className="left"></div>

          <div className="middle">
            {Returntext(contentManagementData, 'PT', lang)}
          </div>

          <BtnCircular
            size={'sm'}
            mainColor={'white'}
            svg={<CloseIcon />}
            disabled={false}
            mode={'active'}
            onClick={cancelClick}
          />
        </div>

        {loader && (
          <div className="pd-loader">
            <Lottie animationData={LoaderAnimation} className="animation" />
          </div>
        )}

        <div className="body-p">
          <div className="d-wrap">
            <div className="txts">
              <div className="main">
                {modeText('PDT')}
              </div>
              <div className="sub">
                {modeText('PDB')}
              </div>
            </div>

            {/* Selector: address vs office pickup */}
            <div className="method-switch">
              <button
                type="button"
                className={`method ${mode === MODE.DELIVERY ? 'active' : ''}`}
                onClick={() => setMode(MODE.DELIVERY)}
              >
                <div className="main">{Returntext(contentManagementData, 'payment_select_delivery', lang)}</div>
              </button>
              <button
                type="button"
                className={`method ${mode === MODE.PICKUP ? 'active' : ''} ${
                  !pickupAvailable ? 'disabled' : ''
                }`}
                onClick={() => pickupAvailable && setMode(MODE.PICKUP)}
                disabled={!pickupAvailable}
              >
                <div className="main">{Returntext(contentManagementData, 'payment_select_office_pickup', lang)}</div>
              </button>
            </div>

            {mode === MODE.DELIVERY && (
              <>
                {address !== '' || address !== undefined ? (
                  <ListItem
                    hasBorder={true}
                    hasPadding={true}
                    hasIcon={true}
                    headline={address.title}
                    description={address.address}
                    style={{ cursor: 'pointer' }}
                    onClick={() => setCadActive(!cadActive)}
                    icon={
                      address.tag === 'home' ? <HomeIcon /> : <WorkIcon />
                    }
                    buttons={
                      <>
                        {address.isDefault && (
                          <OrderTableLabel
                            txt={Returntext(
                              contentManagementData,
                              'default',
                              lang,
                            )}
                          />
                        )}
                        <ArrowRightIcon style={{ marginLeft: '16px' }} />{' '}
                      </>
                    }
                  />
                ) : (
                  <SelectAddress setAddressDrawer={setAddressDrawer} />
                )}

                {cadActive && (
                  <ChooseAddressBox
                    address={address}
                    setAddress={setAddress}
                    setCadActive={setCadActive}
                    setAddressDrawer={setAddressDrawer}
                  />
                )}
              </>
            )}

            {mode === MODE.PICKUP && (
              <PickupLocationBox
                selectedId={pickupLocationId}
                setSelectedId={setPickupLocationId}
              />
            )}
          </div>

          <PaymentNusxa
            setSelectedOrders={setSelectedOrders}
            selectedOrders={selectedOrders}
            activeOrder={activeOrder}
            main={modeText('PST')}
            sub={modeText('PSB')}
            totalValue={totalValue}
            setTotalValue={setTotalValue}
            all={all}
          />

          <PaymentSummary
            nextClick={nextClick}
            selectedOrders={selectedOrders}
            totalValue={totalValue}
            setActiveOrder={setActiveOrder}
            activeOrder={activeOrder}
            address={address}
            cancelClick={cancelClick}
            useraddress={useraddress}
            deliveryMode={mode}
            pickupLocationId={pickupLocationId}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentDrawer;
